import { render, staticRenderFns } from "./guideIndex.vue?vue&type=template&id=20295cc4&"
import script from "./guideIndex.vue?vue&type=script&lang=js&"
export * from "./guideIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports